import React from "react"
import { Link } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import CurveTop from "../components/svg/curveTop"
import ArrowDown from "../components/svg/arrowDown"
import Exist from "../components/svg/exist"
import Consulting from "../components/svg/consulting"
import Coaching from "../components/svg/coaching"
import Benchmark from "../components/svg/benchmark"
import Process from "../components/svg/process"
import Check from "../components/svg/check"
import scrollTo from 'gatsby-plugin-smoothscroll'
import Quotes from "../components/svg/quotes"
import Testimonial from "../components/testimonial"
import Cta from "../components/cta"

const DoPage = () => (

  	<Layout>

      <Seo 
         title="What we do | Media consulting services"
         description="Madclarity helps marketers with media benchmarking, media coaching and media strategy consulting services." 
      />

      <section role="main" className="bg">
         <div className="container">
            <div className="row">
               <div className="sub-hero-content sub-hero">
                  <div className="sub-hero-text">
                     <h1
                        data-sal="slide-up" 
                        data-sal-delay="200"
                        data-sal-duration="400"
                     >What we <span className="blue">do</span></h1>
                     <p
                        data-sal="slide-up" 
                        data-sal-delay="300"
                        data-sal-duration="400"
                     >We help marketers improve the effectiveness and value of their media
                     spend via a unique combination of industry leading software, consulting
                     services and coaching programs.</p>
                     <div className="btn-row"
                        data-sal="slide-up" 
                        data-sal-delay="500"
                        data-sal-duration="400"
                     >
                        <button onClick={() => scrollTo('#consulting')} className="btn-scroll">  
                            <ArrowDown />    
                        </button>
                     </div>
                  </div>
                  <div className="sub-hero-img shi-height img-flip">
                     <Exist />
                  </div>
               </div>
            </div>
         </div>
      </section>

      <div className="curve-btm">
         <CurveTop />
      </div>

      <section className="section-pad" id="consulting">
         <div className="container">
            <div className="row">
                <div className="cols-2-wrapper is-top">
                    <div className="col-2">
                        <div className="col-2-img"
                           data-sal="zoom-in" 
                           data-sal-delay="100"
                           data-sal-duration="300"
                        >
                            <Consulting />
                        </div>
                    </div>
                    <div className="col-2"
                     data-sal="slide-up" 
                     data-sal-delay="200"
                     data-sal-duration="400"
                    >
                        <h2>Consultancy</h2>
                        <p className="lead">Increasing complexity, conflicts of interest, AI slop and conflicting advice make it almost impossible to know whether you're making the right decisions.</p>
                        <p className="lead">Whether you're navigating organisational change, reviewing strategy, assessing agency performance, or defining meaningful KPIs, we bring objective thinking, rigorous analysis and decades of real-world experience from around the globe:</p>
                        <ul className="list-unstyled">
                            <li><span className="check"><Check /></span> Not simply answering your questions … but helping you ask better ones</li>
                            <li><span className="check"><Check /></span> Cutting through complexity and removing guesswork</li>
                        </ul>
                        <p className="lead">We challenge assumptions, evaluate opportunities and ensure every media investment is aligned with your brand strategy, commercial objectives and long-term growth.</p>
                        <p className="lead">Every consulting assignment is tailored to your business. Based on deep industry expertise, we uncover opportunities to improve effectiveness, strengthen accountability and maximise the return on your advertising investment.</p>
                        <p className="lead">… so please feel free to <Link to="/contact">have a chat</Link>.</p>
                    </div>
                </div>
            </div>
         </div>
      </section>

      <section id="benchmarking">
         <div className="container">
            <div className="row">
                <div className="cols-2-wrapper">
                    <div className="col-2 order-2-mob"
                     data-sal="slide-up" 
                     data-sal-delay="200"
                     data-sal-duration="400"
                    >
                        <h3>Media <span className="blue">Benchmarking</span></h3>
                        <p className="lead">Our Media Benchmarking challenges our clients as much as their agencies. It replaces hoping with knowing.</p>
                        <p className="lead">It is clear, objective and constructive and is based on a half a billion dollar, multi-client data base, comprising real spends with independently-sourced audience and appearance data.</p>
                        <p className="lead">It informs and recommends opportunities for continual improvement of effectiveness, performance and value. TV, Online and Out of Home performance is reviewed jointly. The focus is on brand-building, rather than direct response metrics. Madclarity is the only consultancy benchmarking OOH and also the most meaningful brand-building TV metric - <strong>the cost of effective reach</strong>.</p>
                    </div>
                    <div className="col-2 order-1-mob">
                        <div className="col-2-img"
                           data-sal="zoom-in" 
                           data-sal-delay="100"
                           data-sal-duration="300"
                        >
                            <Benchmark />
                        </div>
                    </div>
                </div>
            </div>
         </div>
      </section>

      <section className="section-pad" id="coaching">
         <div className="container">
            <div className="row">
                <div className="cols-2-wrapper">
                    <div className="col-2">
                        <div className="col-2-img"
                           data-sal="zoom-in" 
                           data-sal-delay="100"
                           data-sal-duration="300"
                        >
                            <Coaching />
                        </div>
                    </div>
                    <div className="col-2"
                     data-sal="slide-up" 
                     data-sal-delay="200"
                     data-sal-duration="400"
                    >
                        <h2>Coaching</h2>
                        <p className="lead">As a brand marketer if you are utterly confident that money you spend on media advertising is being spent well then please read no further.</p>
                        <p className="lead">If not then we might be of valuable service.</p>
                        <p className="lead">By instilling confidence in your marketing team via a workshop programme that uses your own briefs from inception to evaluation for relevance and learning.</p>
                        <p className="lead">By giving the team the confidence to ask the hard questions of their own brief and agency proposals.</p>
                        <p className="lead">By providing ongoing advice and guidance in 'real time' during and post workshop phase as new briefs emerge and agencies start responding.</p>
                        <p className="lead">And we have decades of experience running coaching programmes around the globe, so please feel free to <Link to="/contact">have a chat</Link>.</p>
                        <p className="lead">Read more about our <Link to="/faulkner-media-training">media training programme</Link></p>
                    </div>
                </div>
            </div>
         </div>
      </section>

      <section className="section-pad" id="process">
         <div className="container">
            <div className="row">
                <div className="cols-2-wrapper">
                    <div className="col-2 order-2-mob"
                     data-sal="slide-up" 
                     data-sal-delay="200"
                     data-sal-duration="400"
                    >
                        <h4>Process <span className="blue">Evaluation</span></h4>
                        <p className="lead">Process is not the sexiest word in the marketing dictionary, but getting it wrong results in wasting millions of advertising and marketing dollars.</p>
                        <p className="lead">Using our extensive experience with numerous businesses across the Asia Pacific region, we investigate and analyse the way your advertising expenditure is being managed. We deep dive into your entire comms development process, from brand plans and budget allocation through to measurement and evaluation.</p>
                        <p className="lead">We make recommendations for performance improvement on vital areas, including briefing focus, strategy insight & creativity, people skills and implementing learning.</p>
                    </div>
                    <div className="col-2 order-1-mob">
                        <div className="col-2-img"
                           data-sal="zoom-in" 
                           data-sal-delay="100"
                           data-sal-duration="300"
                        >
                            <Process />
                        </div>
                    </div>
                </div>
            </div>
         </div>
      </section>

      <div className="container section-pad-btm">
         <div className="row">
            <div className="col-middle-wrapper">
               <div className="col-middle">
                  <Link to="/why-we-exist" className="btn btn-lg btn-middle">Why we exist</Link>
               </div> 
            </div>
         </div>
      </div>

      <div className="curve-top flip">
         <CurveTop />
      </div>
      <section className="bg testimonials">
         <div className="container">
            <div className="row">
               <div className="testimonial-col-wrapper">
                  <div className="testimonial-col"
                     data-sal="fade" 
                     data-sal-delay="200"
                     data-sal-duration="400"
                  >
                     <Quotes />
                     <div className="test-excerpt">
                        ... tough questions ...
                        <span className="blue"> workable solutions</span> ...
                     </div>
                     <Testimonial
                        quote="Madclarity plays a vital part in monitoring and directing our media investment strategy. They ask the tough questions and through their knowledge base, always provide viable and workable solutions for improvements."
                        name="Scott Baird"
                        title="Chief Marketing Officer, Hungry Jack’s Pty Ltd"
                     />
                  </div>
               </div>
            </div>
         </div>
      </section>
      <div className="curve-btm flip">
         <CurveTop />
      </div>
      
      <Cta />

  </Layout>
)

export default DoPage